'use strict';

angular.module('app.discover', ['ui.router', 'multi-select', 'wu.masonry', 'infinite-scroll'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('home.discover', {
                url: 'discover',
                templateUrl: 'app/discover/partials/discover.html?app_v=deployDate',
                controller: 'DiscoverCtrl',
                controllerAs: 'vm',
                scope: {},
                data: {
                    authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
                    navMarker: ['discover']
                }
            });
    }]).controller('DiscoverCtrl', function ($location,$scope, $rootScope, $http, $filter, $modal, $compile, $state, $window, localStorageService, adminService, measureService, discoverService, $timeout, TRACK_EVENTS, commonConsts) {
        var definitions = angular.copy($rootScope.definitions);
        /*Discover 2.0*/
        var me = this;

        var PARAM_TYPE = {
            MENTION: 0,
            COUNTRY : 1,
            GENDER : 2,
            FLATFORM : 3,
            INFLUENCER : 4,
            PROJECT : 5,
            TOPIC : 6,
            INDUSTRY : 7,
            ACTIVITY :8,
        };

        var CONST = {
            RECENT: 'recent',
            SAVED: 'saved'
        };

        var maxItemLazyLoad = 15;
        var maxItemsPerLoad = 45;
        var keyArray = [13];

        me.timeline = [
            {name: 'None', value: null},
            {name: 'Last 7 days', value: 7},
            {name: 'Last 15 days', value: 15},
            {name: 'Last 30 days', value: 30},
            {name: 'Last 60 days', value: 60, ticked: true},
        ];

        me.orders = [
            {name: 'Latest', value: 'latest', ticked: true},
            {name: 'Highest reach', value: 'reach'},
            {name: 'Best Impact', value: 'impact'}
        ];

        me.currentMention;
        me.currentMentionList = [];

        me.PARAM_TYPE = PARAM_TYPE;
        me.CONST = CONST;

        me.activeParams = [];

        me.currentFilters;
        me.isPostNoData = false;
        me.isInfluencerNoData = false;
        me.tabPostActive = true;
        me.tabInfluencerActive = false;
        me.isCollapsed = true;
        me.isCollapsedRecentPanel = false;
        me.isCollapsedSavedPanel = false;
        me.isShowSearchNameBox = false;
        me.isClearRecentSearch = false;
        me.isClearSavedSearch = false;

        me.recentSearchFilters = [];
        me.savedSearchFilters = [];

        me.loadingMsg = "Loading...";
        me.loadingInfluencerMsg = "You have chosen wide search parameters, please allow a couple of minutes while we find what you're looking for...";

        moment.locale('en', {
            calendar : {
                lastDay : '[Yesterday]',
                sameDay : '[Today]',
                nextDay : '[Tomorrow]',
                lastWeek : '[last] dddd',
                nextWeek : 'dddd',
                sameElse : 'dddd'
            }
        });

        $scope.keywordTypeConsts = angular.copy(commonConsts.KeywordTypes);

        /*old var */
        $scope.currentUser = $rootScope.currentUser;


        $scope.selectedAdvertiser = 0;

        if($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
            $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
        }


        $scope.currentCategory = "post";

        $scope.post_list = [];
        $scope.influencer_list = [];

        $scope.post_list_display = [];
        $scope.influencer_list_display = [];

        $scope.post_list_print = [];
        $scope.influencer_list_print = [];

        $scope.noData = false;

        var offset_post = 0;
        var offset_influencer = 0;

        var isPostLoading = false;
        var isInfluencerLoading = false;

        var collapsePanel = function (panel) {
            if (panel === CONST.RECENT) {
                me.isCollapsedRecentPanel = !me.isCollapsedRecentPanel;
            }
            if (panel === CONST.SAVED) {
                me.isCollapsedSavedPanel = !me.isCollapsedSavedPanel;
            }
        };

        var handleMsgModal = function (msgText) {
            var errorModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                windowClass: 'modal-dialog-mention-error'
            });
            $scope.errorModalInstance = errorModalInstance;
            $scope.errorMessage = msgText;
        };

        var isMentionExisted = function (data) {
            return discoverService.isMentionExisted(data, false)
                .then(function(response){
                    return response.data;
                },
                function () {
                    return false;
                });
        };

        var createNewMention = function (newMention) {
            var typeid;
            var UrlPattern = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
            if(!UrlPattern.test(newMention) && newMention.indexOf("#") != 0){
                typeid = $scope.keywordTypeConsts.KEYWORD;
            } else if(UrlPattern.test(newMention) && newMention.indexOf("#") != 0){
                typeid = $scope.keywordTypeConsts.URL;
            } else if(!UrlPattern.test(newMention) && newMention.indexOf("#") == 0){
                typeid = $scope.keywordTypeConsts.HASH_TAG;
            }

            var data = {
                keyword: newMention,
                keywordType: typeid,
                languages: [0],
                topic_id: 1
            };

            discoverService.addNewProjectMention(data, false)
                .then(function(response){
                },
                function () {
                });
        };

        var mentionSearchEvent = function (keyEvent) {
            if ( keyArray.indexOf(keyEvent.which) !== -1 && me.currentMention) {
                for (var i=0; i<me.currentMentionList.length; i++) {
                    if (me.currentMention === me.currentMentionList[i].name) {
                        return;
                    }
                }

                var countries = [];
                if (me.currentFilters && me.currentFilters[0]) {
                    angular.forEach(me.currentFilters[0].list, function (item) {
                        if (item.value) {
                            countries.push(item.id);
                        }
                    });
                }

                if (countries.length === 0) {
                    countries.push(250);
                }

                var mentionData = {
                    keyword: me.currentMention,
                    countries: countries
                };

                isMentionExisted(mentionData)
                    .then(function (data){
                        var msgText = "Your search includes a new mention that's currently not being tracked. We'll start collecting data now, please check back again later.";
                        if (data && data.keyword && !data.keyword.approved) {
                            handleMsgModal(msgText);
                            // create mention
                            createNewMention(me.currentMention);
                        }
                        if (data && data.keyword && data.keyword.approved === 2) {
                            handleMsgModal(msgText);
                        }



                        var mention = {
                            id : me.currentMention,
                            name : me.currentMention,
                            type: PARAM_TYPE.MENTION

                        };
                        me.currentMentionList.push(mention);
                        me.currentMention = null;
                        buildActiveParam(me.currentFilters);
                    });
            }
        };

        var buildActiveParam = function (filters) {
            me.currentFilters = filters;
            me.activeParams = [];

            for (var n=0; n<me.currentMentionList.length; n++) {
                me.activeParams.push(me.currentMentionList[n]);
            }

            if (filters && filters.length>0) {
                for (var i=0; i<filters.length; i++) {

                    if (filters[i].type === 8) {
                        var pushIntoActiveParams = function (activityType, item, prefix, min, max, unit) {
                            var value = item.split(',');
                            var name, min, max;
                            min = Number(value[0]) === min ? 'Minimum': value[0];
                            max = Number(value[1]) === max ? 'Maximum': value[1];
                            if (unit) {
                                name = prefix + ' = ' + min + unit + ' - ' + max + unit;
                            }
                            else {
                                name = prefix + ' = ' + min + ' - ' + max;
                            }
                            var obj = {
                                id : item,
                                name : name,
                                type: filters[i].type,
                                activityType: activityType
                            }
                            me.activeParams.push(obj);
                        }
                        if (filters[i].list.reach) {
                            pushIntoActiveParams(1, filters[i].list.reach, 'Monthly Reach', 0, 1000000);
                        }
                        if (filters[i].list.engagement) {
                            pushIntoActiveParams(2, filters[i].list.engagement, 'Average Engagements', 0, 1000000);
                        }
                        if (filters[i].list.impact) {
                            pushIntoActiveParams(3, filters[i].list.impact, 'Average Impact', 0, 300, '%');
                        }
                    }
                    else {
                        for (var j=0; j <filters[i].list.length; j++) {
                            if (filters[i].list[j].value) {
                                var obj = {
                                    id : filters[i].list[j].id,
                                    name : filters[i].list[j].name,
                                    type: filters[i].type
                                };
                                me.activeParams.push(obj);
                            }
                        }
                    }
                };
            }
        };

        $scope.$on('discoverFilterChanging', function (scope, data) {
            console.log('discoverFilterChanging');
            buildActiveParam(data.filters);
        });

        var removeParam = function (index) {
            var param = me.activeParams[index];
            if (param.type !== PARAM_TYPE.MENTION) {
                $rootScope.$broadcast('discoverActiveParamChanging', { param: param });
            }
            else {
                for (var i=0; i<me.currentMentionList.length; i++) {
                    if (param.id === me.currentMentionList[i].id) {
                        var idx = i;
                        break;
                    }
                }
                me.currentMentionList.splice(idx, 1);
            }
            me.activeParams.splice(index, 1);
        };

        var clearSearchResult = function () {
            // reset
            offset_post = 0;
            offset_influencer = 0;
            $scope.post_list = [];
            $scope.post_list_display = [];
            $scope.influencer_list = [];
            $scope.influencer_list_display = [];

            $scope.post_list_print = [];
            $scope.influencer_list_print = [];

            $scope.noData = false;

            me.isPostNoData = false;
            me.isInfluencerNoData = false;
        };

        var clearParam = function () {
            me.isCollapsed = true;
            me.isShowSearchNameBox = false;
            if (me.activeParams.length > 0) {
                me.activeParams = [];
                me.currentFilters = [];
                me.currentMention = undefined;
                me.currentMentionList = [];
                $rootScope.$broadcast('discoverActiveParamClear');
                clearSearchResult();
            }
            angular.forEach(me.timeline, function (item) {
                item.ticked = false;
                if (item.value === 60) {
                    item.ticked = true;
                }
            });
            angular.forEach(me.orders, function (item) {
                item.ticked = false;
                if (item.value === 'latest') {
                    item.ticked = true;
                }
            });

            removeLocalCache();
        };

        var implementSearchHistory = function (hit, typeText) {
            var isExisted = false;
            var id = null,
                hitText = hit ? ('(' + hit + ' ' + typeText + ')') : '';
            getDiscoverSearchHistories().then( function(data){
                var recentSearchs = data.recent;
                for (var i=0; i< recentSearchs.length; i++) {
                    if (angular.equals(recentSearchs[i].params, me.activeParams)) {
                        isExisted = true;
                        id = recentSearchs[i].id;
                        break;
                    }
                }
                if (isExisted) {
                    saveSearchFilter(CONST.RECENT, id, hitText, null);
                }
                else {
                    saveSearchFilter(CONST.RECENT, null, hitText, null);
                }
            });
        };

        var performSearch = function (flag, isFromSearchBtnClick) {
            me.isCollapsed = true;
            me.isShowSearchNameBox = false;
            mentionSearchEvent({which: 13});
            if($state.current.url !== "discover") {
                return;
            }

            var params = {
                mentions: [],

                countries: [],
                genders: [],
                platforms: [],
                influencers: [],
                projects: [],
                topics: [],
                industries: [],

                period: 60,
                orderBy: "latest",

                reachFrom: null,
                reachTo: null,
                engagementFrom: null,
                engagementTo: null,
                impactFrom: null,
                impactTo: null,

                limit: maxItemsPerLoad,
                offset: $scope.currentCategory === "post" ? offset_post : offset_influencer
            };

            angular.forEach(me.timeline, function(item) {
                if (item.ticked) {
                    params.period = item.value;
                }
            })
            angular.forEach(me.orders, function(item) {
                if (item.ticked) {
                    params.orderBy = item.value;
                }
            })

            angular.forEach( me.activeParams, function (param) {
                if (param.type === 0) {
                    params.mentions.push(param.id);
                }
                if (param.type === 1) {
                    params.countries.push(param.name);
                }
                if (param.type === 2) {
                    params.genders.push(param.id);
                }
                if (param.type === 3) {
                    params.platforms.push(param.name);
                }
                if (param.type === 4) {
                    params.influencers.push(param.id);
                }
                if (param.type === 5) {
                    params.projects.push(param.id);
                }
                if (param.type === 6) {
                    params.topics.push(param.name);
                }
                if (param.type === 7) {
                    params.industries.push(param.name);
                }
                if (param.type === 8) {
                    var value = param.id.split(',');
                    if (param.activityType === 1) {
                        params.reachFrom = value[0];
                        params.reachTo = value[1];
                    }
                    if (param.activityType === 2) {
                        params.engagementFrom = value[0];
                        params.engagementTo = value[1];
                    }
                    if (param.activityType === 3) {
                        params.impactFrom = value[0];
                        params.impactTo = value[1];
                    }
                }

            });

            if(params.mentions.length === 0 && params.topics.length === 0 && params.countries.length === 0 && params.platforms.length === 0) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = "Please include either a mention in the search bar or use any of the following filters: Countries, Platforms, Topics!";
                return;
            }

            if (flag == true) {
                // reset
                offset_post = 0;
                offset_influencer = 0;
                $scope.post_list = [];
                $scope.post_list_display = [];
                $scope.influencer_list = [];
                $scope.influencer_list_display = [];

                $scope.post_list_print = [];
                $scope.influencer_list_print = [];

                $scope.noData = false;
                me.isPostNoData = false;
                me.isInfluencerNoData = false;

                $rootScope.DiscoverParams = params;
                $rootScope.DiscoverParams.offset = 0;
            }

            // Mixpanel tracking influencer group clicking
            analytics.track(
                TRACK_EVENTS.USE_DISCOVER.EVT_NAME,
                {
                    "action": "Search",
                    "item": TRACK_EVENTS.USE_DISCOVER.ITEM_NAME,
                    "target_type": TRACK_EVENTS.USE_DISCOVER.ITEM_NAME,
                    "params": params
                }
            );

            if (params.projects.length > 0 || params.reachFrom || params.engagementFrom || params.impactFrom) {
                me.loadingMsg = "You have chosen wide search parameters, please allow a couple of minutes while we find what you're looking for...";
            } else {
                me.loadingMsg = "Loading...";
            }

            // Search discover post
            if ($scope.currentCategory === "post") {
                discoverService.searchDiscoverPost(params, false)
                    .then(function(response){
                        if (!response) {
                            return;
                        }
                        // create or update search history with hit
                        var unit = response.total > 1 ? "posts": "post";
                        implementSearchHistory(response.total, unit);

                        if (flag == true) {
                            // reset
                            $scope.post_list = [];
                            $scope.post_list_display = [];
                        }

                        isPostLoading = false;
                        if (response.data && response.data.length >0) {
                            me.isPostNoData = false;
                            var flag1 = 0;
                            angular.forEach(response.data, function (item) {
                                if(flag1 < maxItemLazyLoad){
                                    $scope['post_list_display'].push(
                                        {
                                            url: item.url,
                                            imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                            title: item.title,
                                            influencer_id: item.blog_id,
                                            influencerName: item.influencerName,
                                            formatedDate: item.date,
                                            mentions: item.mentions,
                                            reach: item.reach,
                                            engagement: item.engagement,
                                            impact: item.impact,
                                            relativepath: item.relativepath,
                                            platform_id: item.platform
                                        }
                                    );
                                } else {
                                    $scope['post_list'].push(
                                        {
                                            url: item.url,
                                            imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                            title: item.title,
                                            influencer_id: item.blog_id,
                                            influencerName: item.influencerName,
                                            formatedDate: item.date,
                                            mentions: item.mentions,
                                            reach: item.reach,
                                            engagement: item.engagement,
                                            impact: item.impact,
                                            relativepath: item.relativepath,
                                            platform_id: item.platform
                                        }
                                    );
                                }

                                $scope['post_list_print'].push(
                                    {
                                        url: item.url,
                                        imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                        title: item.title,
                                        influencer_id: item.blog_id,
                                        influencerName: item.influencerName,
                                        formatedDate: item.date,
                                        mentions: item.mentions,
                                        reach: item.reach,
                                        engagement: item.engagementf,
                                        impact: item.impact,
                                        relativepath: item.relativepath,
                                        platform_id: item.platform
                                    }
                                );

                                flag1 = flag1 + 1;
                            })
                        }
                        else {
                            if ($scope.post_list_display && $scope.post_list_display.length === 0) {
                                me.isPostNoData = true;
                            }
                        }

                        $(".lazy-loading-post").hide();
                    }, function (data) {
                        //$scope.errorMessage = data.message;
                        isPostLoading = false;
                        //me.isPostNoData = true;
                        $(".lazy-loading-post").hide();
                        //$rootScope.handleRequestError(err, $scope);
                    });
                $(".lazy-loading-post").show();
            }
            // Search discover influencer
            else if ($scope.currentCategory === "influencer") {
                discoverService.searchDiscoverInfluencer(params, false)
                    .then(function(response){
                        if (!response) {
                            return;
                        }
                        // create or update search history with hit
                        var unit = response.total > 1 ? "influencers": "influencer";
                        implementSearchHistory(response.total, unit);
                        if (flag == true) {
                            // reset
                            $scope.influencer_list = [];
                            $scope.influencer_list_display = [];
                        }

                        isInfluencerLoading = false;
                        if (response.data && response.data.length >0) {
                            me.isInfluencerNoData = false;
                            var flag2 = 0;

                            angular.forEach(response.data, function (item) {
                                for (var ic=0; ic< definitions.countries.length; ic++) {
                                    if (definitions.countries[ic].id === item.influencer_country_id) {
                                        item.influencer_country = definitions.countries[ic];
                                        break;
                                    }
                                }


                                if(flag2 < maxItemLazyLoad){
                                    $scope['influencer_list_display'].push(
                                        {
                                            influencer_id: item.blog_id,
                                            influencerName: item.influencerName,
                                            domain: "//" + item.relativepath,
                                            imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                            formatedDate: item.date,
                                            mentions: item.mentions,
                                            reach: item.reach,
                                            engagement: item.engagement,
                                            impact: item.impact,
                                            relativepath: item.relativepath,
                                            platform_id: item.platform,
                                            platforms: item.platforms,
                                            influencer_country: item.influencer_country,
                                            totalAudience: item.followers,
                                            channels: item.channels
                                        }
                                    );
                                } else {
                                    $scope['influencer_list'].push(
                                        {
                                            influencer_id: item.blog_id,
                                            influencerName: item.influencerName,
                                            domain: "//" + item.relativepath,
                                            imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                            formatedDate: item.date,
                                            mentions: item.mentions,
                                            reach: item.reach,
                                            engagement: item.engagement,
                                            impact: item.impact,
                                            relativepath: item.relativepath,
                                            platform_id: item.platform,
                                            platforms: item.platforms,
                                            influencer_country: item.influencer_country,
                                            totalAudience: item.followers,
                                            channels: item.channels
                                        }
                                    );
                                }
                                $scope['influencer_list_print'].push(
                                    {
                                        influencer_id: item.blog_id,
                                        influencerName: item.influencerName,
                                        domain: "//" + item.relativepath,
                                        imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                        formatedDate: item.date,
                                        mentions: item.mentions,
                                        reach: item.reach,
                                        engagement: item.engagement,
                                        impact: item.impact,
                                        relativepath: item.relativepath,
                                        platform_id: item.platform,
                                        platforms: item.platforms,
                                        influencer_country: item.influencer_country,
                                        totalAudience: item.followers
                                    }
                                );

                                flag2 = flag2 + 1;
                            })
                        }
                        else {
                            if ($scope.influencer_list_display && $scope.influencer_list_display.length === 0) {
                                me.isInfluencerNoData = true;
                            }
                        }
                        $(".lazy-loading-influencer").hide();
                    }, function (err) {
                        //$scope.errorMessage = data.message;
                        isInfluencerLoading = false;
                        //me.isInfluencerNoData = false;
                        $(".lazy-loading-influencer").hide();
                        //$rootScope.handleRequestError(err, $scope);
                    });
                $(".lazy-loading-influencer").show();
            }
            localStorageService.set('discoverActiveParams', me.activeParams);
            localStorageService.set('discoverCurrentFilters', me.currentFilters);
            localStorageService.set('discovercurrentMentionList', me.currentMentionList);
        };

        var selectTab = function (tab) {
            $scope.currentCategory = tab;
            if ($scope[$scope.currentCategory + '_list_display'].length === 0 && me.currentMentionList.length >0) {
                performSearch(false);
            }
        }

        var changeOrder = function () {
            if (me.activeParams.length > 0) {
                performSearch(true);
            }
        };

        var lazyLoad = function() {
            for(var i = 0 ; i < maxItemLazyLoad; i++ ){
                if($scope[$scope.currentCategory + '_list'].length > 0){
                    var item =  $scope[$scope.currentCategory + '_list'][0];
                    $scope[$scope.currentCategory + '_list_display'].push(item);
                    $scope[$scope.currentCategory + '_list'].splice(0, 1);
                }
            }

            if ($scope[$scope.currentCategory + '_list_display'].length > 0 && $scope[$scope.currentCategory + '_list'].length == 0 && (($scope.currentCategory.localeCompare("post") == 0 && !isPostLoading) || ($scope.currentCategory.localeCompare("influencer") == 0 && !isInfluencerLoading))) {
                isPostLoading = $scope.currentCategory.localeCompare("post") == 0 ? true : false;
                isInfluencerLoading = $scope.currentCategory.localeCompare("influencer") == 0 ? true : false;
                if ($scope.currentCategory === "post") {
                    offset_post = offset_post + maxItemsPerLoad;
                } else {
                    offset_influencer = offset_influencer + maxItemsPerLoad;
                }
                performSearch(false);
            }
        }

        var removeLocalCache = function () {
            localStorageService.remove('discoverActiveParams');
            localStorageService.remove('discoverCurrentFilters');
            localStorageService.remove('discovercurrentMentionList');
        };

        var reSearch = function () {
            var activeParams = localStorageService.get("discoverActiveParams");
            var currentFilters = localStorageService.get("discoverCurrentFilters");
            var currentMentionList = localStorageService.get("discovercurrentMentionList");

            if (activeParams && currentFilters && currentFilters.length >0) {
                me.activeParams = activeParams;
                me.currentFilters = currentFilters;
                if (currentMentionList) {
                    me.currentMentionList = currentMentionList;
                }
                $rootScope.$broadcast('discoverReSearchFilterChanging', { filters: me.currentFilters });

                if ($rootScope.isDiscoverPreviousPage) {
                    $scope.currentCategory = $rootScope.previousDiscoverTab;
                    if ($scope.currentCategory === "post") {
                        me.tabPostActive = true;
                    }
                    else {
                        me.tabPostActive = false;
                        me.tabInfluencerActive = true;
                    }
                    performSearch(true);
                    $rootScope.isDiscoverPreviousPage = false;
                }

            }
        };

        $timeout(reSearch, 1000);

        var useSearchFilter = function (filter) {
            var activeParams = filter.params;
            me.activeParams = activeParams;
            var currentMentionList = [];
            for (var i=0; i<activeParams.length; i++) {
                if (activeParams[i].type === 0) {
                    currentMentionList.push(activeParams[i]);
                }
            }
            me.currentMentionList = currentMentionList;
            $rootScope.$broadcast('discoverUsingAvailableParams', { activeParams : activeParams });
            /*if (filter.type === CONST.SAVED) {
                // update hit if item in Saved is the same with item in Recent
                var isExisted = false;
                var id = null,
                    hit = null;
                getDiscoverSearchHistories().then( function(data){
                    var recentSearchs = data.recent;
                    for (var i=0; i< recentSearchs.length; i++) {
                        if (angular.equals(recentSearchs[i].params, filter.params)) {
                            isExisted = true;
                            id = recentSearchs[i].id;
                            hit = recentSearchs[i].hit;
                            break;
                        }
                    }
                    if (isExisted) {
                        saveSearchFilter(CONST.RECENT, id, hit + 1, null);
                    }
                });
            }
            else {
                saveSearchFilter(CONST.RECENT, filter.id, filter.hit + 1, null);
            } */
            performSearch(true);

        };

        var saveSearchFilter = function (type, id, hit, title) {
            if (me.activeParams && me.activeParams.length > 0) {
                var date = new Date();
                var data = {
                    type: type,
                    id: id,
                    date: date.getTime(),
                    title: title,
                    hit: hit,
                    params: me.activeParams
                };
                //console.log(data);
                if (id) {
                    discoverService.updateDiscoverSearchFilters(data, false)
                        .then(function(response){
                            getDiscoverSearchHistories();
                        },
                        function () {

                        });
                }
                else {
                    discoverService.saveDiscoverSearchFilters(data, false)
                        .then(function(response){
                            getDiscoverSearchHistories();
                        },
                        function () {

                        });
                }
            }
        };

        var formatSearchHistoryDate = function (data) {
            for (var i=0; i<data.length; i++) {
                if (data[i].date) {
                    data[i].formatDate = moment(data[i].date).calendar() + moment(data[i].date).format(", MMMM Do YYYY - HH:mm"); // Yesterday, July 10th 2017 - 14:26
                }
            }
            return data;
        };

        var getDiscoverSearchHistories = function () {
            return discoverService.getDiscoverSearchHistories(null, false)
                .then(function(response){
                    var data = response.data;
                    me.recentSearchFilters = formatSearchHistoryDate(data.recent);
                    me.savedSearchFilters = formatSearchHistoryDate(data.saved);
                    return data;
                },
                function () {
                    return [];
                });
        };

        var removeSearchFilter = function (index, type, id) {
            if (type === CONST.RECENT) {
                me.recentSearchFilters.splice(index, 1);
            }
            if (type === CONST.SAVED) {
                me.savedSearchFilters.splice(index, 1);
            }
            deleteDiscoverSearchHistory(id);
        };

        var deleteDiscoverSearchHistory = function (id) {
            discoverService.deleteDiscoverSearchHistory(id, false)
                .then(function(response){
                },
                function () {
                });
        };

        var clearSearchPanel = function (type) {
            if (type === CONST.RECENT) {
                me.recentSearchFilters = [];
                me.isClearRecentSearch = false;
            }
            if (type === CONST.SAVED) {
                me.savedSearchFilters = [];
                me.isClearSavedSearch = false;
            }
            clearDiscoverSearchHistories(type);
        };

        var clearDiscoverSearchHistories = function (type) {
            discoverService.clearDiscoverSearchHistories(type, false)
                .then(function(response){
                },
                function () {
                });
        };

        var saveSearch = function (title) {
            me.isCollapsed = true;
            me.isShowSearchNameBox = false;
            saveSearchFilter(CONST.SAVED, null, 0, title);
        };


        var onSearchPanelClick = function () {
            me.isCollapsed = !me.isCollapsed;
            if (!me.isCollapsed) {
                me.isClearRecentSearch = false;
                me.isClearSavedSearch = false;
                getDiscoverSearchHistories();
            }
        };

        var checkIfCanSaveSearchHistory = function () {
            return discoverService.checkIfCanSaveSearchHistory(false)
                .then(function(response){
                    return response.data;
                },
                function () {
                });
        };

        var onSaveClick = function (){
            if (me.activeParams && me.activeParams.length > 0) {
                checkIfCanSaveSearchHistory().then(function (response){
                    if (response) {
                        me.searchTitle = undefined;
                        me.isShowSearchNameBox = !me.isShowSearchNameBox
                    }
                    else {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = "List has reached its maximum size, please delete one before saving the next one.";
                    }

                });
            }
        };

        var onSaveSearchKeyPress = function (keyEvent) {
            if (keyEvent.which === 13) {
                saveSearch(me.searchTitle)
            }
        };

        var closeSearchPanel = function () {
            me.isCollapsed = true;
        };

        $scope.$watch('vm.isCollapsed', function(value) {
            if (me.isCollapsed) {
                angular.element(document).find('body').removeClass('hidden-scroll-bar');
            }
            else {
                angular.element(document).find('body').addClass('hidden-scroll-bar');
            }
        });

        me.changeOrder = changeOrder;
        me.selectTab = selectTab;
        me.mentionSearchEvent = mentionSearchEvent;
        me.performSearch = performSearch;
        me.removeParam = removeParam;
        me.lazyLoad = lazyLoad;
        me.clearParam = clearParam;
        me.useSearchFilter = useSearchFilter;
        me.removeSearchFilter = removeSearchFilter;
        me.saveSearch = saveSearch;
        me.clearSearchPanel = clearSearchPanel;
        me.onSearchPanelClick = onSearchPanelClick;
        me.collapsePanel = collapsePanel;
        me.onSaveClick = onSaveClick;
        me.onSaveSearchKeyPress = onSaveSearchKeyPress;
        me.closeSearchPanel = closeSearchPanel;

        /*end Discover 2.0*/

        $scope.postOverviewPage = function(index){
            $rootScope.previousPagePost = $location.absUrl();
            $rootScope.isDiscoverPreviousPage = true;
            $rootScope.previousDiscoverTab = $scope.currentCategory;
            var module;
            var url_getPlatform = $rootScope.apiUrl + 'overview/getPlatFormPostByRelativepath?relativepath=' + index.relativepath;
            $http.get(url_getPlatform)
                .success(function (response) {
                    if (response.data == 1) {
                        $state.transitionTo('home.blogPostOverview', {url: index.url, relativepath: index.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (response.data == 2) {
                        $state.transitionTo('home.instagramPostOverview', {url: index.url, relativepath: index.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (response.data == 6) {
                        $state.transitionTo('home.youtubePostOverview', {url: index.url, relativepath: index.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (response.data == 7) {
                        $state.transitionTo('home.facebookPostOverview', {url: index.url, relativepath: index.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    }
            })
        }

        $scope.influencerOverviewPage = function(influencer_id) {
            $rootScope.previousPage = $location.absUrl();
            $rootScope.isDiscoverPreviousPage = true;
            $rootScope.previousDiscoverTab = $scope.currentCategory;
            $state.transitionTo('home.influencerOverview', {influencer_id: influencer_id}, {
                reload: false,
                inherit: true,
                notify: true
            });
        }


        $scope.PlatformIcon = function (platform_id) {
            return adminService.getPlatformIcon(platform_id);
        }

        $scope.CountryFlag = function (country) {
            if(!country) {
                return "";
            }
            return adminService.getCountryFlag(country.code);
        }

        /*$scope.printPdf = function() {
            $rootScope.$broadcast('printPdf');
        }*/

        $scope.getPageNo = function(index) {
            return Math.floor(index / 29) + 1;
        }

        $scope.isPageShown = function(index) {
            return (index != 0 && (index % 29 == 0));
        }

        $scope.$on('beforePrint', function(event, args){
            setTimeout($window.print, 500);
        });


})
